import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';

export const useUser = () => {
  const user = useSelector(selectUser);

  const isAdmin = user?.roles?.includes('administrator');
  const isTop = user?.roles?.includes('top');
  const isHR = user?.roles?.includes('hr');
  const isPR = user?.roles?.includes('pr');
  const isManager = user?.roles?.includes('manager');

  return {
    user,
    isAdmin,
    isTop,
    isHR,
    isPR,
    isManager,
  };
};
